module.exports = __webpack_public_path__ + "img/plant-tree.74033c6a.svg";